import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {registerLocaleData} from '@angular/common';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import localIt from '@angular/common/locales/it';
import {ErrorHandler, ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {environment} from '@src/environments/environment';
import {MatIconModule} from '@angular/material/icon';
import {NavFabMenuComponent} from '@atmi/core/components/nav-fab-menu/nav-fab-menu.component';
import {AuthGuardService} from '@atmi/core/guards/auth-guard.service';
import {appVersion, basePath, filePath, pdfPlaceholderPath, productionMode} from '@atmi/core/injection';
import {AuthorizationInterceptor} from '@atmi/core/interceptors/api-token.service';
import {ErrorsHandler} from '@atmi/core/interceptors/error-handler.service';
import {RequestInterceptorService} from '@atmi/core/interceptors/request-interceptor.service';
import {UndoInterceptorService} from '@atmi/core/interceptors/undo-interceptor.service';
import {BaseApiService} from '@atmi/core/services/base-api.service';
import {InfoApiService} from '@atmi/core/services/info-api.service';
import {RequestService} from '@atmi/core/services/request.service';
import {SourceArcApiService} from '@atmi/core/services/source-arc-api.service';
import {SourceBibApiService} from '@atmi/core/services/source-bib-api.service';
import {SwalService} from '@atmi/core/services/swal.service';
import {TelemetryService} from '@atmi/core/services/telemetry.service';
import {UndoService} from '@atmi/core/services/undo.service';
import {UserService} from '@atmi/core/services/user.service';
import {VocabularyService} from '@atmi/core/services/vocabulary.service';
import {MatBadgeModule} from '@angular/material/badge';
import {RouterModule} from '@angular/router';
import {FreeDraggingDirective} from "@atmi/shared/free-dragging/free-dragging.directive";


registerLocaleData(localIt);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [NavFabMenuComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        TranslateModule.forRoot(),
        MatButtonModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatBadgeModule,
        RouterModule,
        MatTooltipModule,
        FreeDraggingDirective,
        CdkVirtualForOf,
        CdkVirtualScrollViewport,
        CdkFixedSizeVirtualScroll,
        NgOptimizedImage,
        MatRadioModule,
        MatProgressSpinnerModule
    ],
  exports: [
    NavFabMenuComponent
  ]
})
export class CoreModule {

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        AuthGuardService,
        BaseApiService,
        InfoApiService,
        RequestService,
        SourceArcApiService,
        SourceBibApiService,
        SwalService,
        TelemetryService,
        UndoService,
        UserService,
        VocabularyService,
        {
          provide: ErrorHandler,
          useClass: ErrorsHandler,
        },
        {
          provide: filePath,
          useValue: environment.filePath,
        },
        {
          provide: basePath,
          useValue: environment.basePath,
        },
        {
          provide: productionMode,
          useValue: environment.production,
        },
        {
          provide: pdfPlaceholderPath,
          useValue: environment.pdfPlaceholderPath,
        },
        {
          provide: appVersion,
          useValue: environment.appVersion,
        },
        {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: UndoInterceptorService, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true},
      ],
    };
  }

  constructor(
    private readonly translate: TranslateService,
  ) {
    this.translate.setDefaultLang('it');
  }
}
